import MuiDialogActions, { DialogActionsProps } from '@mui/material/DialogActions'

export function DialogActions(props: DialogActionsProps) {
  return <MuiDialogActions {...props} />
}
